import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { FileServiceService } from '../service/file-service.service';

@Component({
  standalone: false,
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {

  date: Date | undefined;
  referenceId = '';
  fileCount = 0;
  email = '';
  confirmationMessage = '';

  constructor(private route: Router, public service: FileServiceService) { }

  ngOnInit(): void {
    const cachedDate = this.service.getCache('submittedDate');
    this.date = cachedDate ? new Date(cachedDate) : new Date();
    this.referenceId = this.service.referenceFileDetails.referenceId || this.service.getCache('referenceId');
    this.fileCount = this.service.referenceFileDetails.submittedFileCount || Number(this.service.getCache('submittedFileCount') || this.service.referenceFileDetails.files.length || 0);
    this.email = this.service.referenceFileDetails.contactEmail || this.service.getCache('contactEmail');
    this.confirmationMessage = this.service.getConfigValue('ConfirmationMessage', '');
    this.route.events.subscribe(event=>{
        if(event instanceof NavigationStart && event.navigationTrigger === "popstate" ){
          this.exit();
        }
    })

  }

  exit() {
    this.service.referenceFileDetails.files = [];
    this.service.referenceFileDetails.caseActivityKey = null;
    this.service.reset();
    this.service.clearCache();
    let url = window.localStorage.getItem('securityCode');
    this.route.navigate(['/' + url]);
  }

}
